import { render, staticRenderFns } from "./sortable-th.vue?vue&type=template&id=451228fe&scoped=true"
import script from "./sortable-th.vue?vue&type=script&lang=js"
export * from "./sortable-th.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451228fe",
  null
  
)

export default component.exports